import { Control, FormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextInput from '../../form/TextInput';
import { User } from '../../../data/models/user.model';
import validationUtils from '../../../services/validationUtils';
import CheckboxInput from '../../form/CheckboxInput';

interface BasicInfoFormProps {
  control: Control;
  formState: FormState<any>;
  requiredFieldMessage: string;
  readOnly: boolean;
  disableActiveCheckbox: boolean;
  isCurrentUser: boolean;
}

export default function BasicInfoForm({
  control,
  formState,
  requiredFieldMessage,
  readOnly,
  disableActiveCheckbox,
  isCurrentUser,
}: BasicInfoFormProps) {
  const { t } = useTranslation('common');
  let disabledMessage: string | undefined;
  if (disableActiveCheckbox) {
    disabledMessage = t('users.newUsersActive') || undefined;
  }

  return (
    <>
      <TextInput
        label={t('users.firstName')}
        name="FirstName"
        required={true}
        disabled={readOnly}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
        }}
      />
      <TextInput
        label={t('users.middleName')}
        name="MiddleName"
        disabled={readOnly}
        required={false}
        control={control}
        errors={formState.errors}
      />
      <TextInput
        label={t('users.lastName')}
        name="LastName"
        required={true}
        disabled={readOnly}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
        }}
      />
      <TextInput
        label={t('users.email')}
        name="Email"
        required={true}
        disabled={readOnly}
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
          pattern: validationUtils.emailValidation(),
        }}
        inputProps={{ maxLength: 255 }}
      />
      {/* <SelectMenu
        label={t('users.userType')}
        name="TypeID"
        required={true}
        values={userTypes}
        valueAttr="UserCategoryTypeID"
        labelAttr="UserCategoryTypeName"
        control={control}
        errors={formState.errors}
        rules={{
          required: requiredFieldMessage,
        }}
      /> */}
      {!isCurrentUser && (
        <CheckboxInput
          label={t('common.active')}
          name="IsActive"
          control={control}
          disabledMessage={disabledMessage}
          disabled={readOnly || disableActiveCheckbox}
        />
      )}
    </>
  );
}
